import React from "react";
import work_1 from "../../assets/images/WORK-PROCESS-1.png";
import work_2 from "../../assets/images/WORK-PROCESS4.png";
import work_3 from "../../assets/images/work-img5.png";
import work_4 from "../../assets/images/work-img7.png";
const HomePageWrokProcess = () => {
  return (
    <div className="flex justify-center items-center flex-col py-28">
      <div className=" text-[#243FFA] text-[16px] text-center font-normal font-outfit">
        WORK PROCESS
      </div>
      <h2 className="xl:text-[52px] text-[32px] font-outfit text-center font-semibold text-[#0F2349]">
        Let’s See How We Work
      </h2>
      <div className="xl:w-3/4 w-[95%] mt-8  flex justify-center gap-6 items-center flex-col lg:flex-row">
        <div className=" lg:w-1/2 w-full flex lg:justify-end justify-center flex-col md:flex-row gap-6 ">
          <div className="xl:w-64 pt-11  pb-6 rounded-xl flex flex-col justify-center items-center  hover:border-blue-700 gap-1">
            <figure className="h-[200px] group hover-white-filter mb-6 relative flex justify-center items-center w-[200px] border-[1px] border-blue-600 border-dashed rounded-full ">
              <div className="w-[160px] h-[160px]  flex justify-center items-center rounded-full border-[1px] border-dashed group-hover:bg-blue-600 text-white">
                <img src={work_1} alt="work-img-1" className="" />
              </div>
              <div className="absolute -bottom-4 text-[12px] bg-[#243ffa]  rounded-full text-white w-8 h-8 flex justify-center items-center font-bold font-outfit">
                01
              </div>
            </figure>
            <p className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Seeing Patients
            </p>
            <p className="text-[#757887] leading-[1.5rem] text-center text-[16px] font-outfit my-2 font-normal">
              Rure dolor aen voluta zesse cillum…
            </p>
          </div>
          <div className="xl:w-64 pt-11  pb-6 rounded-xl flex flex-col justify-center items-center  hover:border-blue-700 gap-1">
            <figure className="h-[200px] group hover-white-filter mb-6 relative flex justify-center items-center w-[200px] border-[1px] border-blue-600 border-dashed rounded-full ">
              <div className="w-[160px] h-[160px]  flex justify-center items-center rounded-full border-[1px] border-dashed group-hover:bg-blue-600 text-white">
                <img src={work_2} alt="work-img-1" className="" />
              </div>
              <div className="absolute -bottom-4 text-[12px] bg-[#243ffa]  rounded-full text-white w-8 h-8 flex justify-center items-center font-bold font-outfit">
                02
              </div>
            </figure>
            <p className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Making a Diagnosis
            </p>
            <p className="text-[#757887] leading-[1.5rem] text-center text-[16px] font-outfit my-2 font-normal">
              Gure dolor aen voluta zesse cillum…
            </p>
          </div>
        </div>
        <div className=" lg:w-1/2 w-full flex lg:justify-start justify-center flex-col md:flex-row gap-6 ">
          <div className="xl:w-64 pt-11  pb-6 rounded-xl flex flex-col justify-center items-center  hover:border-blue-700 gap-1">
            <figure className="h-[200px] group hover-white-filter mb-6 relative flex justify-center items-center w-[200px] border-[1px] border-blue-600 border-dashed rounded-full ">
              <div className="w-[160px] h-[160px]  flex justify-center items-center rounded-full border-[1px] border-dashed group-hover:bg-blue-600 text-white">
                <img src={work_3} alt="work-img-1" className="" />
              </div>
              <div className="absolute -bottom-4 text-[12px] bg-[#243ffa]  rounded-full text-white w-8 h-8 flex justify-center items-center font-bold font-outfit">
                03
              </div>
            </figure>
            <p className="text-[#0F2349] text-[22px] font-semibold font-outfit text-center">
              Developing a Treatment
            </p>
            <p className="text-[#757887] leading-[1.5rem] text-center text-[16px] font-outfit my-2 font-normal">
              Hure dolor aen voluta zesse cillum…
            </p>
          </div>
          <div className="xl:w-64 pt-11  pb-6 rounded-xl flex flex-col justify-center items-center  hover:border-blue-700 gap-1">
            <figure className="h-[200px] group hover-white-filter mb-6 relative flex justify-center items-center w-[200px] border-[1px] border-blue-600 border-dashed rounded-full ">
              <div className="w-[160px] h-[160px]  flex justify-center items-center rounded-full border-[1px] border-dashed group-hover:bg-blue-600 text-white">
                <img src={work_4} alt="work-img-1" className="" />
              </div>
              <div className="absolute -bottom-4 text-[12px] bg-[#243ffa]  rounded-full text-white w-8 h-8 flex justify-center items-center font-bold font-outfit">
                04
              </div>
            </figure>
            <p className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Documenting Patient
            </p>
            <p className="text-[#757887] leading-[1.5rem] text-center text-[16px] font-outfit my-2 font-normal">
              Zure dolor aen voluta zesse cillum…
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageWrokProcess;
